import script from "./instituteProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./instituteProfile.vue?vue&type=script&setup=true&lang=js"

import "./instituteProfile.vue?vue&type=style&index=0&id=4514cdf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4514cdf4"]])

export default __exports__